import React, { Component } from 'react';
import { TabPane, Card, Row, Col, ButtonDropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { MODAL_TYPE_FORM, CURRENCY_FORMAT_FULL_FIGURES, CURRENCY_FORMAT_K, CURRENCY_FORMAT_LAKH, CURRENCY_FORMAT_CR, CURRENCY_FORMAT_MN, CURRENCY_FORMAT_BN } from '../../../constants';
// import { CURRENCY_FORMAT_FULL_FIGURES } from '../../../constants';
import { getSpeedometerValues, formatPaymentNumbers, getPaymentValue } from '../helper';
import CanvasMeter from 'canvas-meter';
import { getSpeedoSkin } from '../speedometerconfig';
import { PAYMENT_SCORE, VERTICAL_AGGREGATION_DATA, CUG_SCORE } from '../constants';
import './style.scss';
import CorporateModal from '../../../components/UI/CorporateModal/index';
import VerticalDataModal from './vertical-data-modal/index';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
/* import VerticalTab from './vertical-tabs/index';
import VerticalTabContent from './verticle-tabs-content/index'; */
class CreditWorthinessScoreTabContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grahpNavActiveTab: 'v-tab-1',
            levelOneCurrencyFormatDropdownOpen: false,
            levelOneSelectedCurrencyFormat: CURRENCY_FORMAT_FULL_FIGURES,
            paymentRiskGrade: [],
            selectedFormat: CURRENCY_FORMAT_K,
            paymentValues: [],
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_FORM,
            modalTitle: ''
        }
    }
    componentDidMount() {
        (this.props.id === PAYMENT_SCORE) ? setPageView('/Corporate/PaymentScore', document.location.href) : setPageView('/Corporate/CUGScore', document.location.href);
    }
    componentDidUpdate(prevProps) {
        if (this.props.riskGrade !== prevProps.riskGrade) {
            const meterValues = getSpeedometerValues(this.props.riskGrade, this.props.paymentData.paymentRisk);
            let meter
            if (this.props.id === PAYMENT_SCORE) {
                meter = new CanvasMeter(document.getElementById("meter"));
            } else {
                meter = new CanvasMeter(document.getElementById("cug-meter"));
            }
            meter.draw(meterValues.totalScore, meterValues.min, meterValues.max, 45, 45);
            meter.setOptions(getSpeedoSkin(meterValues));
        }
    }
    handleGraphsNavTab = (activeTab) => {
        this.setState({
            grahpNavActiveTab: activeTab
        })
    }
    levelOneCurrencyToggle = () => {
        this.setState((prevState) => ({
            levelOneCurrencyFormatDropdownOpen: !prevState.levelOneCurrencyFormatDropdownOpen
        }))
    }
    fromatChanger = (event) => {
        goolgeAnalyticsEvents('Corporate', 'Update Payment Risk Currency Type', 'Payment Risk Currency Type', event.target.innerText);
        let tempPaymentValue = formatPaymentNumbers(event.target.innerText, this.props.paymentValueData, this.props.paymentData);
        this.setState({
            selectedFormat: event.target.innerText,
            paymentValues: tempPaymentValue
        })
    }
    handleVerticalData = (clickedData) => {
        this.modalCloseHandler();
        this.setState({
            modalTitle: (clickedData.headerName).substr(0, (clickedData.headerName).indexOf('(')),
            body: <VerticalDataModal conversionUnit={this.state.selectedFormat} paymentMonthlyDataId={clickedData.monthlyDataList[0].id} paymentValue={this.props.paymentValueData} />
        })
    }
    modalCloseHandler = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal
        }))
    }
    render() {
        return (
            <TabPane tabId="payment-score">
                <Row>
                    <Col sm='18'>
                        <h6 className="mb-4"><b>Payment Risk Score:</b> {this.props.paymentData.counterpartyName}</h6>
                    </Col>
                    <Col sm='6' className='clearfix'>
                        <ButtonDropdown isOpen={this.state.levelOneCurrencyFormatDropdownOpen} toggle={this.levelOneCurrencyToggle} direction="down" className="align-items-center mb-4 float-right">
                            <DropdownToggle className="unit-conversion py-0" color='link' caret>
                                {this.state.selectedFormat}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={this.fromatChanger} className="p-3">{CURRENCY_FORMAT_FULL_FIGURES}</DropdownItem>
                                <DropdownItem onClick={this.fromatChanger} className="p-3">{CURRENCY_FORMAT_K}</DropdownItem>
                                <DropdownItem onClick={this.fromatChanger} className="p-3">{CURRENCY_FORMAT_LAKH}</DropdownItem>
                                <DropdownItem onClick={this.fromatChanger} className="p-3">{CURRENCY_FORMAT_CR}</DropdownItem>
                                <DropdownItem onClick={this.fromatChanger} className="p-3">{CURRENCY_FORMAT_MN}</DropdownItem>
                                <DropdownItem onClick={this.fromatChanger} className="p-3">{CURRENCY_FORMAT_BN}</DropdownItem>
                            </DropdownMenu>
                        </ButtonDropdown>
                    </Col>
                </Row>

                <div className="p-0 mb-4">
                    <div className="d-flex flex-column flex-sm-row border-bottom-body-bg">
                        {/* <h6 className="text-capitalize mb-3 d-sm-none">Rubix Payment Score</h6> */}
                        <Card body className="risk-meter">
                            <h6 className="font-size-small mb-5 d-none d-sm-block"><b>Rubix Payment Score</b></h6>
                            {(this.props.id === PAYMENT_SCORE) ? <div className="speedometer-wrapper" style={{ textAlign: 'center' }}>
                                <canvas height="160" id="meter"></canvas>
                            </div> : <div className="speedometer-wrapper" style={{ textAlign: 'center' }}>
                                    <canvas height="160" id="cug-meter"></canvas>
                                </div>}


                            <div className="text-center title mt-3">
                                {this.props.paymentData.riskGrade}&nbsp; &nbsp; {(this.props.paymentData.riskDescription) ? (this.props.paymentData.riskDescription) : ''}
                            </div>
                        </Card>

                        {/* <h6 className="d-sm-none">Rubix’s Analysis & Recommendation</h6> */}
                        <Card body className="meter-analytics flex-grow-1">
                            <h6 className="font-size-small d-none d-sm-block"><b>Rubix’s Analysis & Recommendation</b></h6>

                            <ul className="analytics-detail -large w-100">
                                {(this.props.paymentData.levelOneKeyFields) ? this.props.paymentData.levelOneKeyFields.map(p => {
                                    return (
                                        (p.value) ?
                                            <li key={p.name}>
                                                <h1 title={(parseFloat(p.value))}>
                                                    {(p.type === 'NUMERIC') ? getPaymentValue(p, this.props.paymentValueData) : p.value}
                                                </h1>
                                                <p>{p.headerName}</p> <br className="d-none d-sm-block" />
                                            </li> : ''
                                    )
                                }) : ''}
                            </ul>
                        </Card>
                    </div>
                    {/* <h6 className="mb-3 d-sm-none">Key data fields</h6> */}
                    <Card body className="meter-analytics">
                        <h6 className="font-size-small d-none d-sm-block"><b>Key Payment Statistics</b></h6>
                        <ul className="analytics-detail -small">
                            {(this.props.paymentData.levelTwoKeyFields) ? this.props.paymentData.levelTwoKeyFields.map(p => {
                                let value = p.value;
                                return (
                                    (value) ? <li onClick={(p.monthlyDataList) ? () => this.handleVerticalData(p) : null} key={p.name} className={(p.type !== 'NUMERIC') ? 'text-value' : ''}>
                                        <h1>{
                                            (p.type !== 'NUMERIC') ? value.toString() : getPaymentValue(p, this.props.paymentValueData)
                                        }
                                        </h1>
                                        <p>{(p.monthlyDataList) ? <a href='javascript:void(0)'>{p.headerName}</a> : p.headerName}</p> <br className="d-none d-sm-block" />
                                    </li> : ''
                                )
                            }) : ''}
                        </ul>
                    </Card>
                </div>
                {/* <h6 className="mb-4">Payment Risk Score Trend</h6>
            <div className="mb-4">
                <Card body>
                    <Row>
                        <Col sm="6">
                            <VerticalTab graphActiveTabCallback={this.handleGraphsNavTab} />
                        </Col>
                        <Col>
                            <VerticalTabContent graphActiveTab={this.state.grahpNavActiveTab} />
                        </Col>
                    </Row>
                </Card>
            </div> */}
                <CorporateModal toShow={this.state.showModal}
                    modalClosed={this.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle}
                />
            </TabPane >
        )
    }
}

export default CreditWorthinessScoreTabContent